<template>
  <NoteModal @dismiss="$emit('dismiss')">
    <p class="font_blue">・{{ $t('sameTimeDeliveryNote.separate.title') }}</p>
    <p>{{ $t('sameTimeDeliveryNote.separate.description') }}</p>
    <p class="font_blue"><br>・{{ $t('sameTimeDeliveryNote.sameTime.title') }}</p>
    <p v-html="$t('sameTimeDeliveryNote.sameTime.description')"></p>
  </NoteModal>
</template>

<script>
import NoteModal from '@/components/lib/NoteModal.vue'

export default {
  components: { NoteModal },
}
</script>
